import React from 'react'
import './home.css'
import { NavLink } from 'react-router-dom';
import Footer from '../../component/footer/footer'
import { Button, Row, Col, Collapse } from 'antd';
import { ArrowRightOutlined, PlusOutlined } from '@ant-design/icons';
import firstimage from '../../assets/img/home-1-img.svg'
import secondimage from '../../assets/img/home-2-img.svg'
import thirdimage from '../../assets/img/home-3-img.svg'
import logo from '../../assets/img/logo.svg'

const Home = () => {
    const { Panel } = Collapse;

    return(
        <div>
                <div className="home_banner">
                    <div className="banner_header">
                        <div className="logo">
                            <ul>
                                <li><img src={logo} alt=""/></li>
                            </ul>
                        </div>

                        <div className="sign_in">
                            <NavLink exact to="/sign-in" >
                                <Button type="primary">Sign In</Button>
                            </NavLink>
                        </div>
                    </div>
                    
                    <div className="banner_text">
                        <h1 className="banner_h1">Play Games on any console against anyone online.</h1>
                        <h4 className="banner_h4">Play anywhere. Join anytime.</h4>
                        <Button type="primary">TRY IT NOW <ArrowRightOutlined /> </Button>
                    </div>
                </div>

                <div className="home_body">
                    <Row gutter={[16, 24]}>
                        <Col className="gutter-row home_body_text" sm = {{ span: 24 }} md = {{ span: 12 }} lg = {{ span: 12 }} xl ={{ span: 12 }}>
                            <h2 className="home_body_h2">Join any Game of 
                            your choice. </h2>
                            <h4 className="home_body_h4">Join and play your favourite Games on 
                            Playstation, Xbox, PCs, Mobile and more 
                            online.</h4>
                        </Col>
                        <Col className="gutter-row" sm = {{ span: 24 }} md = {{ span: 12 }} lg = {{ span: 12 }} xl={{ span: 12 }}>
                            <img src={firstimage} alt="" style={{ width: '100%', height: 'auto' }}/>
                        </Col>
                    </Row>
                </div>
                <hr className="home_divider"/>

                <div className="home_body">
                    <Row gutter={[16, 24]}>
                        <Col className="gutter-row" sm = {{ span: 24 }} md = {{ span: 12 }} lg = {{ span: 12 }} xl={{ span: 12 }}>
                            <img src={secondimage} alt="" style={{ width: '100%', height: 'auto' }}/>
                        </Col>
                        <Col className="gutter-row home_body_text" sm = {{ span: 24 }} md = {{ span: 12 }} lg = {{ span: 11, offset: 1 }} xl ={{ span: 11, offset: 1 }}>
                            <h2 className="home_body_h2">Confirm your winnings 
                            to cashout.</h2>
                            <h4 className="home_body_h4">Update your Game status after every match
                            to confirm the losing end and cashout  almost
                            immediately.</h4>
                        </Col>
                    </Row>
                </div>
                <hr className="home_divider"/>

                <div className="home_body">
                    <Row gutter={[16, 24]}>
                        <Col className="gutter-row home_body_text" sm = {{ span: 24 }} md = {{ span: 12 }} lg = {{ span: 12 }} xl ={{ span: 12 }}>
                            <h2 className="home_body_h2">Play anywhere</h2>
                            <h4 className="home_body_h4">Play all available Games and enjoy the 
                            comfort of playing online with as little 
                            payment to keep you going.</h4>
                        </Col>
                        <Col className="gutter-row" sm = {{ span: 24 }} md = {{ span: 12 }} lg = {{ span: 12 }} xl={{ span: 12 }}>
                            <img src={thirdimage} alt="" style={{ width: '100%', height: 'auto' }}/>
                        </Col>
                    </Row>
                </div>

                <div className="home_faq">
                    <div className="home_faq_header">
                        <h1>Frequently Asked Questions</h1>
                    </div>

                    <Collapse
                        bordered={false}
                        defaultActiveKey={['1']}
                        expandIcon={({ isActive }) => <PlusOutlined rotate={isActive ? 45 : 0} />}
                        expandIconPosition='right'
                        className="site-collapse-custom-collapse"
                        accordion
                    >
                        <Panel header="What is PlayarOne?" key="1" className="site-collapse-custom-panel">
                            <p>PlayarOne is an onlilne gaming service connecting Gamers across  multiple Video Game consoles, PCs 
                            and mobile devices providing online-first experience to thousands of inter-connected Players.

                            You can create or browse available Games to join online whenever you want - earning money playing 
                            against other Players online all for one low monthly price. Discover popular Games created at intervals 
                            at your current level to beat the streak!</p>
                        </Panel>
                        <Panel header="How much does PlayarOne cost?" key="2" className="site-collapse-custom-panel">
                            <p> A dog is a type of domesticated animal. Known for its loyalty and faithfulness, it can be found
                            as a welcome guest in many households across the world.</p>
                        </Panel>
                        <Panel header="How do I play?" key="3" className="site-collapse-custom-panel">
                            <p> A dog is a type of domesticated animal. Known for its loyalty and faithfulness, it can be found
                            as a welcome guest in many households across the world.</p>
                        </Panel>
                        <Panel header="Do I need online ID to play?" key="4" className="site-collapse-custom-panel">
                            <p> A dog is a type of domesticated animal. Known for its loyalty and faithfulness, it can be found
                            as a welcome guest in many households across the world.</p>
                        </Panel>
                        <Panel header="How do I washout?" key="5" className="site-collapse-custom-panel">
                            <p> A dog is a type of domesticated animal. Known for its loyalty and faithfulness, it can be found
                            as a welcome guest in many households across the world.</p>
                        </Panel>
                        <Panel header="How do I cancel?" key="6" className="site-collapse-custom-panel">
                            <p> A dog is a type of domesticated animal. Known for its loyalty and faithfulness, it can be found
                            as a welcome guest in many households across the world.</p>
                        </Panel>
                    </Collapse>
                
                    <div className="home_faq_bottom">
                        <Button type="primary">TRY IT NOW <ArrowRightOutlined /> </Button>
                        <p>Ready to play, Sign up to access your account.</p>
                    </div>
                </div>

                <Footer />


        </div>
    );
}

export default Home;